export default {
    ABSCESSO_DENTO_ALVEOLAR: 1,
    ALTERACAO_EM_TECIDOS_MOLES: 2,
    DOR_DE_DENTE: 3,
    FENDAS_FISSURAS_LABIO_PALATAIS: 4,
    FLUOROSE_DENTARIA_MODERADA_SEVERA: 5,
    TRAUMATISMO_DENTO_ALVEOLAR: 6,
    NAO_IDENTIFICADO: 99,
}